import React from "react";
import { ConceptContent } from "../../data/concept/ConceptContent.ts";
import "../styles/conceptPage.scss";
import standardImage from "../../images/ZukanRedLogo.png";

const ConceptContents = [
  new ConceptContent(
    "Content 1",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    null,
    standardImage
  ),
  new ConceptContent(
    "Content 2",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    null,
    standardImage
  ),
  new ConceptContent(
    "Content 3",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    null,
    standardImage
  ),
];
export function ConceptPage() {
  return (
    <section className="root">
      <h3>Concept Page</h3>
      {ConceptContents.map((content, i) => {
        return (
          <section className="content-section" key={content.title + i}>
            <h4>{content.title}</h4>
            <section className="content-inner-section">
              <div className="content-description">{content.content}</div>
              <img className="content-image" src={content.image} alt={`Content ${i}`} />
            </section>
          </section>
        );
      })}
    </section>
  );
}
